<template>
  <b-col cols="12">
    <div class="d-flex align-items-center justify-content-between pagination_box">
      <div class="dataTables_paginate paging_simple_numbers float-start">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination
            :total-rows="paginationData.totalCount"
            :per-page="pageSize"
            v-model="page"
            align="center"
            page-class="pagination-button-container"
            aria-controls="articles-table"
            v-if="paginationData.totalCount > pageSize"
          />
        </ul>
      </div>
      <div class="d-flex flex-row-reverse align-items-center gap-3 drop_don_box">
        <Dropdown pagination :items="dropDownListItems" @dropdownSelected="pageSizeSetter($event)" v-if="paginationData.totalCount > 10" />
        <div class="page_status">نمایش {{ currentPage }} از {{ paginationData.totalPages }}</div>
        <div class="me-5 total">تعداد کل {{ slugToText(exactParam) }} {{ paginationData.totalCount }} عدد</div>
        <div>
          <slot name="excel"></slot>
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
import { urlQueriesMixins } from '../../../utils/mixins'
import Dropdown from '../../common/Dropdown.vue'
export default {
  name: 'pagination',
  props: {
    dropDownListItems: {
      type: Array,
    },
    getData: {
      type: Function,
    },
    paginationData: {
      type: Object,
    },
  },
  data() {
    return {
      page: 1,
    }
  },
  components: {
    Dropdown,
  },
  mixins: [urlQueriesMixins],
  computed: {
    exactParam() {
      return this.$route.params.slug
    },
  },
  methods: {
    slugToText(data) {
      switch (data) {
        case 'user':
          return 'مشتریان'
        case 'invoice':
          return 'فاکتور ها'
        case 'product':
          return 'محصولات'
        case 'productAdv':
          return 'محصولات'
        default:
          'داده ها'
          break
      }
    },
    pageSizeSetter(item) {
      const route = this.$route
      let teamTaskType = null
      const query = this.searchQuery
      const pageNumber = 1
      let pageSize = item
      let filters = this.filters
      let queryParams = null

      if (route.name === 'transactions-fromListsWallet' || route.name === 'transactions-fromUserManagement') {
        teamTaskType = ''
        queryParams = {
          key: teamTaskType,
          search: query,
          filters: filters,
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize.count),
          fieldSearchs: [
            {
              fieldName: 'UserId',
              type: 'string',
              text: route.params.id,
            },
            {
              fieldName: 'Coin',
              type: 'string',
              text: route.params.slug,
            },
          ],
        }
      } else if (route.path === '/list/totalcomments') {
        let fieldSearches = []
        if (route.query.filters) {
          route.query.filters.forEach((element) => {
            fieldSearches.push({ fieldName: 'Status', text: String(element.key) })
          })
        }
        teamTaskType = route.params.slug
        queryParams = {
          key: teamTaskType,
          query: query,
          filters: filters,
          fieldSearchs:
            fieldSearches.length && route.query.pageNumber
              ? fieldSearches
              : [
                  {
                    fieldName: 'Status',
                    text: '0',
                  },
                ],
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize.count),
        }
      } else if (route.name === 'courses-package') {
        queryParams = {
          key: 'skilluppackagecourses',
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize.count),
          fieldSearchs: [
            {
              fieldName: 'PackageId',
              type: 'string',
              text: route.params.packageId,
            },
          ],
        }
      } else {
        teamTaskType = route.params.slug
        queryParams = {
          key: teamTaskType,
          query: query,
          filters: filters,
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize.count),
        }
      }
      // let queryParams = {
      //   key: teamTaskType,
      //   query: query,
      //   filters: filters,
      //   pageNumber: parseInt(pageNumber),
      //   pageSize: parseInt(pageSize.count),
      // }
      this.$store.dispatch('urlQueries/setPageSize', pageSize.count)
      this.$store.dispatch('urlQueries/setCurrentPage', 1)
      this.getData(queryParams)
      this.changeRoute()
    },
    changeRoute() {
      const query = this.searchQuery
      let pageNumber = this.currentPage.toString()
      let perPage = this.pageSize.toString()
      let filters = this.filters != null ? this.filters : ''
      let queries = [{ pageNumber: pageNumber }, { query: query }, { filters: filters }, { perPage: perPage }]
      const thisRoute = this.$route.path
      let queryKey = []
      let queryValue = []
      for (let i = 0; i < queries.length; i++) {
        if (Object.entries(queries[i])[0][1].length > 0) {
          queryKey.push(Object.entries(queries[i])[0][0])
          queryValue.push(Object.entries(queries[i])[0][1])
        }
      }
      let queryObject = {}
      for (let i = 0; i < queryKey.length; i++) {
        queryObject[queryKey[i]] = queryValue[i]
      }
      this.$router.push({ path: thisRoute, query: queryObject })
    },
    fetchPageData(page) {
      this.changeRoute()
      const route = this.$route
      let teamTaskType = null
      const query = this.searchQuery
      const pageNumber = page
      const pageSize = parseInt(this.pageSize)
      let filters = this.filters
      let queryParams = null
      if (route.path === '/list/totalcomments') {
        let fieldSearches = []
        if (route.query.filters) {
          route.query.filters.forEach((element) => {
            fieldSearches.push({ fieldName: 'Status', text: String(element.key) })
          })
        }

        const params = {
          key: 'totalcomments',
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize),
          filters: route.query.filters ? route.query.filters : null,
          fieldSearchs:
            fieldSearches.length && route.query.pageNumber
              ? fieldSearches
              : [
                  {
                    fieldName: 'Status',
                    text: '0',
                  },
                ],
        }
        return params
      }
      if (route.path === `/list/skillupdiscount/detail/${this.$route.params.id}`) {
        let fieldSearches = []
        if (route.query.filters) {
          route.query.filters.forEach((element) => {
            fieldSearches.push({ fieldName: 'Status', text: String(element.key) })
          })
        }

        const params = {
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize),
          filters: route.query.filters ? route.query.filters : null,
          fieldSearchs: [
            {
              fieldName: 'ProductType',
              type: 'string',
              text: this.$route.query.filters.join(),
            },
          ],
        }
        return params
      }
      if (route.name === 'transactions-fromListsWallet' || route.name === 'transactions-fromUserManagement') {
        teamTaskType = ''
        queryParams = {
          key: teamTaskType,
          search: query,
          filters: filters,
          pageNumber: pageNumber,
          pageSize: pageSize,
          fieldSearchs: [
            {
              fieldName: 'UserId',
              type: 'string',
              text: route.params.id,
            },
            {
              fieldName: 'Coin',
              type: 'string',
              text: route.params.slug,
            },
          ],
        }
      } else if (route.name === 'courses-package') {
        queryParams = {
          key: 'skilluppackagecourses',
          pageNumber: page,
          pageSize: parseInt(this.pageSize),
          fieldSearchs: [
            {
              fieldName: 'PackageId',
              type: 'string',
              text: route.params.packageId,
            },
          ],
        }
      } else {
        teamTaskType = route.params.slug
        queryParams = {
          key: teamTaskType,
          query: query,
          filters: filters,
          pageNumber: pageNumber,
          pageSize: pageSize,
        }
      }
      // let queryParams = {
      //   key: teamTaskType,
      //   query: query,
      //   filters: filters,
      //   pageNumber: pageNumber,
      //   pageSize: pageSize,
      // }
      setTimeout(() => {
        this.getData(queryParams)
      }, 500)
    },
  },
  watch: {
    page(newPage, oldPage) {
      if (newPage === oldPage) return
      if (newPage === parseInt(this.$route.query.pageNumber)) return
      if (newPage > 1) {
        this.$store.dispatch('urlQueries/setCurrentPage', parseInt(newPage))
      } else {
        this.$store.dispatch('urlQueries/setCurrentPage', 1)
      }
      this.fetchPageData(parseInt(newPage))
    },
    searchQuery(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$store.dispatch('urlQueries/setCurrentPage', 1)
        this.page = 1
      }
    },
  },
  mounted() {
    this.page = this.currentPage
  },
}
</script>

<style scoped>
.dropdown-select {
  border: 1px solid #ced4da;
  box-sizing: border-box;
  border-radius: 3px;
  outline: none;
}

@media (min-width: 1069px) {
  .page_status {
    display: block !important;
  }
  ::v-deep .bv-d-xs-down-none {
    display: block !important;
  }
}
@media (min-width: 100px) {
  .page_status {
    display: none;
  }
  ::v-deep .bv-d-xs-down-none {
    display: none;
  }
}

@media (max-width: 705px) {
  .pagination_box {
    justify-content: flex-start !important;
    gap: 0.5rem !important;
  }

  .total {
    margin-left: 0 !important;
  }
}

@media (max-width: 685px) {
  .pagination_box {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
  }
  .drop_don_box {
    gap: 1px;
  }
}

@media (max-width: 378px) {
  .total {
    font-size: 12px;
  }
}
</style>
